import { type Observable } from 'rxjs';

import { type MyreRoute } from '../interfaces';

export abstract class AbstractMenuPermissionService {
  public abstract hasAccessToRoute$(route: MyreRoute): Observable<boolean>;
}
